/**
 * Load section JS only when the section is near the viewport (homepage).
 */
(function () {
  if (window.__eckoDeferSectionScripts) return;
  window.__eckoDeferSectionScripts = true;

  function loadScript(src) {
    if (!src || document.querySelector('script[src="' + src + '"]')) {
      return Promise.resolve();
    }
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  }

  function bootSection(el) {
    if (el.dataset.eckoScriptsLoaded === 'true') return;
    el.dataset.eckoScriptsLoaded = 'true';
    var scripts = (el.dataset.eckoScripts || '').split(',').filter(Boolean);
    scripts.reduce(function (chain, src) {
      return chain.then(function () {
        return loadScript(src.trim());
      });
    }, Promise.resolve());
  }

  function observe(el) {
    if (!('IntersectionObserver' in window)) {
      bootSection(el);
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          bootSection(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '240px 0px', threshold: 0.01 }
    );
    observer.observe(el);
  }

  function init() {
    document.querySelectorAll('[data-ecko-defer-scripts]').forEach(observe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
